namespace Gamification.Gamification {
    export interface ChecklistForm {
        IdAssetEsperienza: Serenity.LookupEditor;
        IdChecklist: Serenity.IntegerEditor;
        Nome: Serenity.TextAreaEditor;
        Progressivo: Serenity.IntegerEditor;
        NodiList: Nodi2Editor;
    }

    export class ChecklistForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.Checklist';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ChecklistForm.init)  {
                ChecklistForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.TextAreaEditor;
                var w3 = Nodi2Editor;

                Q.initFormType(ChecklistForm, [
                    'IdAssetEsperienza', w0,
                    'IdChecklist', w1,
                    'Nome', w2,
                    'Progressivo', w1,
                    'NodiList', w3
                ]);
            }
        }
    }
}
